import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { ProductMetaInfo, Key } from './productMetaInfo'
import { IDetailPageState } from '../../reducers'
import {
  sanitizedRequestContextSelector,
  IRequestContext
} from '../../selectors/requestContext'
import { FatalComponent, createDataFatal } from '../error/withFatalCheck'
import { pageSelectors } from '../../selectors/basicState'

const VISIBLE_ITEMS_BTF = 5
const retailBtfKeys = [
  Key.Actors,
  Key.Producers,
  Key.ReleaseYear,
  Key.Studios,
  Key.RegRating,
  Key.ContentDescriptors,
  Key.PurchaseRights,
  Key.Format,
  Key.Devices
]

const pvBtfKeys = [
  Key.Producers,
  Key.Studios,
  Key.Amr,
  Key.ContentDescriptors,
  Key.Actors
]

export interface Props {
  productDetails?: WpsRuntime.atv.wps.DetailFragmentModelProps
  requestContext: IRequestContext
}

const ConnectedBtfProductMetaInfo = ({
  productDetails,
  requestContext
}: Props) => {
  if (!productDetails) {
    return (
      <FatalComponent {...createDataFatal('BTF Product Details missing')} />
    )
  } else {
    return (
      <ProductMetaInfo
        {...productDetails}
        fields={requestContext.isRetail ? retailBtfKeys : pvBtfKeys}
        showHeader
        expandedItemsCount={VISIBLE_ITEMS_BTF}
        id="btf-product-details"
      />
    )
  }
}

const mapStateToProps = (state: IDetailPageState): Props => ({
  productDetails: pageSelectors.detail(state),
  requestContext: sanitizedRequestContextSelector(state)
})

export const BtfProductMetaInfo = connect(mapStateToProps)(
  ConnectedBtfProductMetaInfo
)
